export default __webpack_public_path__ + "static/media/icon-moon.038e80ca.svg";